export default __webpack_public_path__ + "static/media/Type-1.bd6d9bc2.svg";